import { Loader2 } from 'lucide-react';

/**
 * The ONE loading spinner. Three sanctioned sizes:
 *  - 14 (default) — inline: buttons, cells, chips, dropdown rows, load-more
 *    footers. Swaps 1:1 with the 13-15px icon scale, zero layout shift.
 *  - 20 — block: centered placeholder for a bounded region (panel, modal
 *    list, tab content, map/chart overlay). Pass size={20} explicitly.
 *  - 32 — page: route-level gates (h-screen loads, full-screen overlays).
 *
 * `color` recolors the glyph for the two contexts carbon/40 can't survive:
 * white (dark scrims, brand/dark buttons) and brand (orange accents).
 * The only sanctioned bespoke loader is PDFPreviewClient's generation ring.
 */
type MinimalLoaderProps = {
  className?: string;
  size?: number;
  color?: 'white' | 'brand';
};

const COLOR_CLASS: Record<NonNullable<MinimalLoaderProps['color']>, string> = {
  white: 'text-white',
  brand: 'text-brand',
};

export function MinimalLoader({ className = '', size = 14, color }: MinimalLoaderProps) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Loader2 className={`animate-spin ${color ? COLOR_CLASS[color] : 'text-carbon/70'}`} size={size} />
    </div>
  );
}
